const DefaultWorklist = {
  0: 'All Cases',
  1: 'NEW',
  2: 'In Review',
  3: 'Pending',
  4: 'Needs Consultation',
  5: 'On Hold',
  6: 'Completed',
  7: 'Reserved-1',
  8: 'Reserved-2',
  9: 'Reserved-3',
  10: 'Reserved-4',
  
  'All Cases': 0,
  'NEW': 1,
  'In Review': 2,
  'Pending': 3,
  'Needs Consultation': 4,
  'On Hold': 5,
  'Completed': 6,
  'Reserved-1': 7,
  'Reserved-2': 8,
  'Reserved-3': 9,
  'Reserved-4': 10,
};

export default DefaultWorklist;